import PropTypes from 'prop-types'
import InputBasic from '../InputBasic'
import { Icon } from 'ui-framework'
import React, { useState } from 'react'
import Preloader from 'bzx-common/src/shared-components/Preloader'

export function Input(props) {
  const [isFocused, setIsFocused] = useState(false)
  const { className, discreet, icon, withLoader, isLoading, value, ...otherProps } = props
  let extraClass = `${discreet ? 'inputfield-discreet' : 'inputfield'} ${className || ''}`

  if (icon) {
    extraClass += ' input-icon--input-padding'
    return (
      <div className="input-container">
        <InputBasic className={extraClass} {...otherProps} value={value} />
        <Icon name={icon} className="input-icon" width="20px" />
      </div>
    )
  }

  if (withLoader) {
    const showLoader = !isFocused && isLoading
    const inputText = showLoader ? '' : value
    return (
      <div className="input-container">
        <InputBasic
          value={inputText}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className={extraClass}
          {...otherProps}
        />
        {showLoader && (
          <div className="preloader-container">
            <Preloader width="80px" />
          </div>
        )}
      </div>
    )
  }

  return <InputBasic className={extraClass} {...otherProps} value={value} />
}

Input.propTypes = {
  discreet: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  style: PropTypes.shape({}),
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  type: PropTypes.string,
  onChangeEmit: PropTypes.oneOf(['event', 'value', 'name-value']),
  step: PropTypes.number,
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  readOnly: PropTypes.bool,
  icon: PropTypes.string,
  withLoader: PropTypes.bool,
  focusOnMount: PropTypes.bool,
  disabled: PropTypes.bool,
}

Input.defaultProps = {
  discreet: false,
  isLoading: false,
  withLoader: false,
}

export default React.memo(Input)
